import { InjectionToken } from '@angular/core';

/**
 * Current wall-clock time in epoch ms. Injectable so tests can drive it with a fake clock —
 * `fakeAsync`/`tick` does not advance `Date.now()`.
 */
export const NOW = new InjectionToken<() => number>('Current time (epoch ms)', {
  providedIn: 'root',
  factory: () => () => Date.now(),
});
